import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useMutation } from '@tanstack/react-query'
import type { PatronReferralPointsManual } from 'types/api'

interface usePostManualPatronReferralPointsProps {
  onSuccess?: (
    data: PatronReferralPointsManual,
    variables: PatronReferralPointsManual
  ) => Promise<void>
  onError?: (error: Error, variables: PatronReferralPointsManual) => void
}

export const usePostManualPatronReferralPoints = ({
  onSuccess,
  onError,
}: usePostManualPatronReferralPointsProps) => {
  const post = useTypedApiClient({
    path: '/admin/patrons/referralPoints/manual',
    method: 'post',
  })

  return useMutation({
    mutationFn: async (manualReferralPoints: PatronReferralPointsManual) => {
      const { data } = await post(manualReferralPoints)
      return data
    },
    onSuccess: async (data, variables) => {
      await onSuccess?.(data, variables)
    },
    onError,
  })
}
